// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
// InsysOnboardingIntakeFormAPI Handles the gRPC endpoints related to the onboarding intake form.
// The endpoints are implemented in the insys-onboarding-intake-form service.
export const InsysOnboardingIntakeFormAPI = {
    // GetFormByLocationIDRequest Returns the form for the given locationID
    GetFormByLocationID(fn, req) {
        return fn(`/insys/intake-form/v1/intake-form?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // UpdateFormByLocationID Updates the form for the passed location id with the passed values.
    UpdateFormByLocationID(fn, req) {
        return fn(`/insys/intake-form/v1/intake-form`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteFormByLocationID Deletes the form for the passed location id.
    DeleteFormByLocationID(fn, req) {
        return fn(`/insys/intake-form/v1/intake-form?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // ResetFormByLocationID Resets the formCompletedAt field of the intake form
    ResetFormByLocationID(fn, _req) {
        return fn(`/insys/intake-form/v1/reset`, { method: "PATCH" });
    },
    // GetOperationsByLocationID Returns the operation status for the passed location
    GetOperationsByLocationID(fn, req) {
        return fn(`/insys/intake-form/v1/operation-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // DeleteCompletedOperationByLocationIDAndOperationID Deletes the operation from the completed operations table for the combination of passed location and operation
    // DANGER: NOT TO BE USED UNDER NORMAL CIRCUMSTANCES IN PRODUCTION.
    DeleteCompletedOperationByLocationIDAndOperationID(fn, req) {
        try {
            fm.validateUrlParam(req["operationId"], "operationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insys/intake-form/v1/operation/completed/${req["operationId"]}?${fm.renderURLSearchParams(req, ["operationId"])}`, { method: "DELETE" });
    },
    // GetEmailStatusLogsByLocationID  Returns the email logs collected from the EmailStatusChanges topic
    GetEmailStatusLogsByLocationID(fn, req) {
        return fn(`/insys/intake-form/v1/email-status-logs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetLocationHierarchy Returns own location details if passed single/child locationID and returns all child location
    // details if passed parent locationID
    GetLocationHierarchy(fn, req) {
        return fn(`/insys/intake-form/v1/location-hierarchy?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // OnboardLocation Used to create the form for a location and send the intake form email to the contact
    OnboardLocation(fn, req) {
        return fn(`/insys/intake-form/v1/onboard`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetPhoneNumbers is used to get phone numbers for given locationID
    GetPhoneNumbers(fn, req) {
        return fn(`/insys/intake-form/v1/phonenumbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ValidatePhoneNumbers(fn, req) {
        return fn(`/insys/intake-form/v1/validate/phonenumbers`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // CompleteFormByLocationID sets the formCompletedAt & isManuallyCompleted field of the intake form
    CompleteFormByLocationID(fn, req) {
        return fn(`/insys/intake-form/v1/complete-form`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
};
